<template>
  <section class="style-section">
    <div class="title-guide">建立一个桥梁结构计算模型</div>
    <div class="content-guide">
      目标：建立一座1跨30m简支T梁桥的中梁单梁模型（采用横向分布系数法）
    </div>
    <div class="content-guide">
      <li>打开程序，进入装配式单梁模块，</li>
      <div class="img-guide">
        <div class="title-img">
          <el-image
            style="width: 300px; height: 180px"
            :src="url0"
            :fit="fit"
          />
        </div>
      </div>
      <li>数据库采用“04版部版标准图”，结构类型修改为“T梁”，跨径选择“30”</li>
      <div class="img-guide">
        <div class="title-img">
          <el-image
            style="width: 574px; height: 126px"
            :src="url1"
            :fit="fit"
          />
        </div>
      </div>
      <li>修改跨径为：1-29.96（梁长）</li>
      <div class="img-guide">
        <div class="title-img">
          <el-image
            style="width: 376px; height: 135px"
            :src="url2"
            :fit="fit"
          />
        </div>
      </div>
      <li>点击“中中距”按钮，在弹出窗体中输入“2.4”（表示中梁的中距为2.4m）</li>
      <div class="img-guide">
        <div class="title-img">
          <el-image
            style="width: 727px; height: 437px"
            :src="url3"
            :fit="fit"
          />
        </div>
      </div>
      <li>填入横向分布系数“0.4”</li>
      <div class="img-guide">
        <div class="title-img">
          <el-image
            style="width: 448px; height: 129px"
            :src="url4"
            :fit="fit"
          />
        </div>
      </div>
      <li>保存项目文件后，点击“导出”按钮，输入文件名得到mct格式文件</li>
      <div class="img-guide">
        <div class="title-img">
          <el-image
            style="width: 391px; height: 264px"
            :src="url5"
            :fit="fit"
          />
        </div>
      </div>
    </div>
    <li style="text-align: left;">
      打开Midas Civil，先新建项目，然后点击“文件<el-icon><Right /></el-icon
      >导入<el-icon><Right /></el-icon>mct文件，
      一个包含完整计算参数的模型就完成了！
    </li>
    <div class="img-guide">
      <div class="demo-image__preview">
        <el-image
          class="size-img"
          style="height: 200px"
          :src="url6"
          :zoom-rate="1.2"
          :max-scale="1.5"
          :min-scale="0.2"
          :preview-src-list="srcList6"
          :initial-index="0"
          fit="cover"
        />
      </div>
    </div>
  </section>
  <el-divider></el-divider>
  <div style="height: 120px"></div>
</template>
<script>
export default {
  data() {
    return {
      url0: require("@/assets/png/use-0.png"),
      url1: require("@/assets/png/use-1.png"),
      url2: require("@/assets/png/use-2.png"),
      url3: require("@/assets/png/use-3.png"),
      url4: require("@/assets/png/use-4.png"),
      url5: require("@/assets/png/use-5.png"),
      url6: require("@/assets/png/use-6.png"),
      fit: "fill",
      srcList6: [require("@/assets/png/use-6.png")],
    };
  },
};
</script>
